<div class="row align-items-center">
    <div class="primeng-datatable-container col-12">
            <div class="p-datatable p-component p-datatable-scrollable">

                <div class="p-datatable-wrapper">
                    <table role="table" class="p-datatable-table p-datatable-scrollable-table"
                        style="min-width: 50rem;">

                        <thead class="p-datatable-thead">
                            <tr>
                                <th>{{l("KeyName")}}</th>
                                <th>{{l("Content")}}</th>
                            </tr>
                        </thead>
                        <tbody class="p-element p-datatable-tbody" *ngFor="let item of templateData">
                            <tr  *ngIf="!item.isHidden">

                                <td>
                                    <span> {{item.keyName}}</span><span>{{item.keyProperty}}</span><span> {{item.keyItemprop}}</span>
                 
                                </td>
                                <td>
                                    <input type="text" (ngModelChange)="valueChange()" (blur)="valueChange()"  [disabled]="!item.isAllowEdit || isDisable" class="form-control" [(ngModel)]="item.content" name="Content" />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>
    </div>

</div>